import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { COMPONENTS } from '../../routers/constants'
import classes from './index.module.scss'

export const Header = () => {
  return (
    <Element className={classes.header} style={{ borderColor: '#E5E5E8' }}>
      <div className="wFitContent">
        <Link to={COMPONENTS.alerts.components.alertList.route}>
          <Element
            className={classes.backBtn}
            style={{ color: '#3A414B', borderColor: '#D5D5D5' }}
          >
            <Element className="dFlex alignItemsCenter" style={{ gap: 4 }}>
              <Element>
                <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
              </Element>
              <Element elementName="span">
                <Translate value="alertSetting.BACK_TO_ALERT_LIST" />
              </Element>
            </Element>
          </Element>
        </Link>
      </div>

      <Element
        className={classes.title}
        style={{ fontSize: 24, color: '#0553A5' }}
      >
        <Translate value="alertSetting.ALERT_SETTINGS" />
      </Element>
    </Element>
  )
}
